
import * as helpersDZSVG from '../js_dzsvg/_dzsvg_helpers';
export const player_setup_skipad = (selfClass) => () => {


  var translate_skipad = 'Skip Ad';
  var dzsvg_translate_youcanskipto = 'you can skip to video in ';

  if (window.dzsvg_translate_youcanskipto) {
    dzsvg_translate_youcanskipto = window.dzsvg_translate_youcanskipto;
  }
  if (window.dzsvg_translate_skipad) {
    translate_skipad = window.dzsvg_translate_skipad;
  }

  let inter_time_counter_skipad = null;
  let time_counter_skipad = null;

  let $ = jQuery;

  if (selfClass.ad_status === 'first_played') {
    return false;
  }

  console.log('selfClass.isAd - ', selfClass.isAd);
  if (selfClass.isAd) {
    let skipad_timer = 0;

    if (selfClass.dataType === 'image' || selfClass.dataType === 'inline') {
      skipad_timer = 0;
    }
    if (selfClass.dataType === 'selfHosted' || selfClass.dataType === 'youtube') {
      skipad_timer = 1001;
    }

    selfClass.cthis.appendOnce('<div class="skipad-con"></div>', '.skipad-con');
    selfClass.$adSkipCon = selfClass.cthis.find('.skipad-con').eq(0);



    if(helpersDZSVG.is_mobile() && selfClass.cthis.attr('data-adskip_delay')){

      // -- TBC - skip ad notice on mobile
      selfClass.$adSkipCon.html("Play the ad for the skip ad counter to appear");
      selfClass.$adSkipCon.attr('data-ad-status', 'waiting_for_play');
    }

    if (typeof selfClass.cthis.attr('data-adskip_delay') != 'undefined') {
      skipad_timer = Number(selfClass.cthis.attr('data-adskip_delay'));
    }

    time_counter_skipad = skipad_timer;
    if (skipad_timer !== 1001) {
      setTimeout(function () {

        time_counter_skipad = 0;
        selfClass.$adSkipCon.html(translate_skipad);
        selfClass.$adSkipCon.bind('click', function () {
          if ($(this).attr('data-ad-status') === 'can_be_clicked_for_end_ad') {
            selfClass.handleVideoEnd();
          }
        })
        selfClass.$adSkipCon.attr('data-ad-status', 'can_be_clicked_for_end_ad');
      }, skipad_timer * 1000);

      if (skipad_timer > 0) {
        inter_time_counter_skipad = setInterval(tick_counter_skipad, 1000);
      }
    }
  }


  selfClass.ad_status = 'first_played';


  function tick_counter_skipad() {

    if (time_counter_skipad > 0) {
      time_counter_skipad = time_counter_skipad - 1;
      if (selfClass.$adSkipCon) {
        selfClass.$adSkipCon.html(dzsvg_translate_youcanskipto + time_counter_skipad);
        selfClass.$adSkipCon.attr('data-ad-status', 'ad_status_is_ticking');
      }
    } else {
      clearInterval(inter_time_counter_skipad);
    }
  }
}


